import { render, staticRenderFns } from "./BookingActivity.vue?vue&type=template&id=ec4133fe&scoped=true&"
import script from "./BookingActivity.vue?vue&type=script&lang=js&"
export * from "./BookingActivity.vue?vue&type=script&lang=js&"
import style0 from "./BookingActivity.vue?vue&type=style&index=0&id=ec4133fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4133fe",
  null
  
)

export default component.exports